import { useEffect, useState } from "react";
import { getPortalProfileMenuStyle } from "../utils/profileMenuPortal";

/** Tracks fixed portal placement for an account profile menu. */
export function useAccountProfilePortal(
  open,
  anchorRef,
  { mobileMq = "(max-width: 1024px)", menuWidth } = {},
  layoutDeps = []
) {
  const [menuStyle, setMenuStyle] = useState(null);

  useEffect(() => {
    if (!open) {
      setMenuStyle(null);
      return undefined;
    }

    const updatePosition = () => {
      setMenuStyle(
        getPortalProfileMenuStyle(anchorRef.current, { mobileMq, menuWidth })
      );
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- layoutDeps are intentional resize triggers
  }, [open, anchorRef, mobileMq, menuWidth, ...layoutDeps]);

  return menuStyle;
}
